/**
 * Юридические константы, нужные больше чем одному приложению.
 *
 * Тексты самих документов живут на лендинге (frontend/site/src/content/legal.ts)
 * и никуда больше не нужны. Здесь — только то, что показывают все три фронта:
 * адреса документов и формулировки согласий под галочками. Держать их копиями
 * в каждом приложении нельзя: согласие с одним текстом в витрине и другим
 * в кабинете — это два разных согласия, а доказывать придётся одно.
 *
 * LEGAL_VERSION дублируется в internal/domain/legal/legal.go (его пишет бэкенд
 * рядом с согласием) и в frontend/site/src/content/legal.ts. Совпадение всех
 * трёх проверяет TestLegalVersionMatchesFrontend в test/build.
 */

/** Редакция документов в формате YYYY-MM-DD. */
export const LEGAL_VERSION = "2026-10-05";

/** Домен, на котором опубликованы документы. */
export const LEGAL_SITE = "prilavokapp.ru";

/**
 * Адреса документов — абсолютные. Витрина открывается внутри Telegram
 * на другом домене, относительная ссылка увела бы покупателя в никуда.
 */
export const legalUrls = {
  privacy: `https://${LEGAL_SITE}/privacy`,
  agreement: `https://${LEGAL_SITE}/oferta`,
} as const;

// Формулировки согласий здесь сознательно не лежат: текст для продавца
// показывает только кабинет, текст для покупателя — только витрина, и общего
// у них ничего нет. Каждая формулировка размечена ссылками прямо в вёрстке
// своего приложения, а её неизменность стережёт тест этого приложения.
